import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import sanitizeHtml from '../utils/sanitizeHtml';
import './HtmlEditor.css';

// Editor de texto enriquecido con más opciones que el básico (encabezados,
// colores, listas, sangría, citas, bloques de código, enlaces, imágenes) y
// un botón "Editar HTML" para escribir/pegar HTML directamente cuando el
// editor visual no alcanza. Todo se sanea (DOMPurify) antes de salir de
// este componente — no se permite <script>, manejadores onXxx, iframes ni
// URLs javascript:; la barrera real vive en el backend, esto es defensa en
// profundidad + evita que el propio editor renderice algo peligroso.
const modules = {
    toolbar: [
        [{ header: [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ align: [] }],
        ['blockquote', 'code-block'],
        ['link', 'image'],
        ['clean']
    ]
};

const HtmlEditor = ({ value, onChange, placeholder, readOnly }) => {
    const [modoHtml, setModoHtml] = useState(false);
    const [borrador, setBorrador] = useState(value || '');

    const cambiarAVisual = () => {
        const limpio = sanitizeHtml(borrador);
        onChange(limpio);
        setModoHtml(false);
    };

    const cambiarAHtml = () => {
        setBorrador(value || '');
        setModoHtml(true);
    };

    if (readOnly) {
        return <div className="av-html-readonly" dangerouslySetInnerHTML={{ __html: sanitizeHtml(value) }} />;
    }

    return (
        <div className="av-html-editor">
            <div className="d-flex justify-content-end mb-1">
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={modoHtml ? cambiarAVisual : cambiarAHtml}
                >
                    <i className={`fas ${modoHtml ? 'fa-eye' : 'fa-code'} me-1`}></i>
                    {modoHtml ? 'Volver al editor visual' : 'Editar HTML'}
                </button>
            </div>

            {modoHtml ? (
                <>
                    <textarea
                        className="form-control font-monospace av-html-textarea"
                        rows={12}
                        value={borrador}
                        onChange={(e) => setBorrador(e.target.value)}
                        placeholder="Escribe o pega el HTML aquí..."
                        spellCheck={false}
                    />
                    <small className="text-muted">
                        Al volver al editor visual se limpia automáticamente cualquier etiqueta o atributo peligroso (scripts, iframes, manejadores de eventos).
                    </small>
                </>
            ) : (
                <ReactQuill value={value || ''} onChange={(html) => onChange(sanitizeHtml(html))} modules={modules} placeholder={placeholder} />
            )}
        </div>
    );
};

export default HtmlEditor;
